import { FC } from 'react';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { useSlideout } from '../../../../hooks/use-slideout';
import SlideOutCard from '../../../shared/slide-out-card';
import { ApptRequestWidgetWrapper } from './appt-requests-widget.styles';
import { useApptRequestsWidget } from './hooks/use-appt-requests-widget/use-appt-requests-widget';
import { ApptRequestWidgetRouter } from './navigation/router';
import { ApptRequestsViewSkeleton } from './views/appt-requests/appt-requests.skeleton';

export const ApptRequestsWidgetComponent: FC = () => {
  const { publish } = useEventBus();
  const { isLoading, routeHistory, goBack } = useApptRequestsWidget();
  const { isApptRequestsVisible, hasHistory, back } = useSlideout();

  const handleBackClick = () => {
    if (routeHistory.length > 1) {
      goBack();
    } else if (hasHistory) {
      back();
    }
  };

  const handleClose = () => publish({ messageType: 'closeWidget' });

  return (
    <SlideOutCard
      isVisible={isApptRequestsVisible}
      onClose={handleClose}
      onBackClick={hasHistory || routeHistory.length > 1 ? handleBackClick : undefined}
    >
      <ApptRequestWidgetWrapper>
        {isLoading ? <ApptRequestsViewSkeleton /> : <ApptRequestWidgetRouter />}
      </ApptRequestWidgetWrapper>
    </SlideOutCard>
  );
};
